































import Vue, { PropType } from 'vue'

import { EventService } from 'base/services/EventService'
// Import Widget-Components
import Activity from '../../activity/Activity.vue'
import AlarmInformations from '../../alarm-informations/AlarmInformationsWidget.vue'
import Countdown from '../../countdown/CountdownWidget.vue'
import Crewtarget from '../../crewtarget/CrewtargetWidget.vue'
import DirectMessages from '../../direct-messages/DirectMessages.vue'
import DragDropIndicator from '../../drag-drop-indicator/DragDropIndicator.vue'
import HeaderWidget from '../../header/HeaderWidget.vue'
import IframeWidget from '../../iframe/IframeWidget.vue'
import MapWidget from '../../map/MapWidget.vue'
import MessagesWidget from '../../messages-widget/MessagesWidget.vue'
import Messenger from '../../messenger/Messenger.vue'
import Report from '../../report/Report.vue'
import Spacer from '../../spacer/WidgetSpacer.vue'
import StatusCompact from '../../status-compact/StatusCompactWidget.vue'
import StatusDetail from '../../status-detail/StatusDetailWidget.vue'
import VehicleStatus from '../../vehicle-status/VehicleStatusWidget.vue'
import VehicleStatusHistory from '../../vehicle-status-history/VehicleStatusHistory.vue'

import { DragDropAction, DragDropService } from '../drag-drop'
import { ResizeAction, ResizeDirection, ResizeService, ResizeUnit } from '../resize'
import { Widget } from './WidgetInterface'
import { WidgetHeightType } from './WidgetTypes'

export default Vue.extend({
  components: {
    Activity,
    AlarmInformations,
    Countdown,
    DragDropIndicator,
    // https://vuejs.org/v2/guide/components-edge-cases.html#Circular-References-Between-Components
    WidgetContainer: () => import('../../container/WidgetContainer.vue'),
    Report,
    VehicleStatus,
    VehicleStatusHistory,
    Spacer,
    StatusCompact,
    StatusDetail,
    MapWidget,
    Crewtarget,
    HeaderWidget,
    IframeWidget,
    MessagesWidget,
    DirectMessages,
    Messenger
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    },
    isEditable: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    dashboardSettings: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isSelected: false,
      isResizing: false,
      dragAction: DragDropAction,
      resizeAction: ResizeAction,
      highlighted: false
    }
  },
  computed: {
    canResizeVertically(): boolean {
      const heightType = this.widget.heightType
      return (heightType === WidgetHeightType.grid) || (heightType === WidgetHeightType.pixel)
    },
    widgetHeightType(): WidgetHeightType | undefined {
      return this.widget.heightType
    },
    widgetHeight(): number | undefined {
      return this.widget.height
    },
    widgetInnerCssClasses(): any[] {
      return [
        'widget__content',
        {
          'box': !this.widget.isFrameless,
          'widget__content--frameless': this.widget.isFrameless,
          'widget__content--no-padding': this.widget.isFrameless || this.widget.noPadding
        }
      ]
    },
    widgetCssClasses(): any[] {
      return [
        'col-' + this.widget.size,
        'grid-item',
        'widget',
        'widget-' + this.widget.type,
        {
          'widget--selected': this.isSelected,
          'widget--editable': this.isEditable,
          'widget--resizing': this.isResizing,
          'widget--highlight': this.highlighted
        }
      ]
    }
  },
  methods: {
    startResizeAny(event: any) {
      const resizeUnit = (this.widget.heightType === WidgetHeightType.pixel) ? ResizeUnit.pixel : ResizeUnit.grid
      this.resizeAction.beginResize(event, ResizeDirection.any, resizeUnit)
    },
    startResizeHorizontal(event: any) {
      const resizeUnit = (this.widget.heightType === WidgetHeightType.pixel) ? ResizeUnit.pixel : ResizeUnit.grid
      this.resizeAction.beginResize(event, ResizeDirection.horizontal, resizeUnit)
    },
    startResizeVertical(event: any) {
      const resizeUnit = (this.widget.heightType === WidgetHeightType.pixel) ? ResizeUnit.pixel : ResizeUnit.grid
      this.resizeAction.beginResize(event, ResizeDirection.vertical, resizeUnit)
    },
    onDeselect() {
      this.isSelected = false
    },
    onSelect() {
      if (!this.isEditable) {
        return
      }
      this.isSelected = true
      EventService.$emit('widget-select', this)
    },
    onWidgetSelectEvent(selectedWidget: Widget | any) {
      if (selectedWidget === this) {
        return
      }

      this.onDeselect()
    },
    onWidgetSelectByUuidEvent(widgetUUID: string) {
      if (this.widget.wbUUID !== widgetUUID) {
        return
      }

      this.onSelect()
    },
    onResizeStart(action: ResizeAction, direction: ResizeDirection) {
      this.isResizing = true
    },
    onResizeEnd(action: ResizeAction) {
      this.isResizing = false
    },
    onResize(action: ResizeAction, size: number, direction: ResizeDirection) {
      let widgetUUID = this.widget.wbUUID

      if (direction === ResizeDirection.horizontal) {
        EventService.$emit('widget-update-size', widgetUUID, size)
      }

      if (direction === ResizeDirection.vertical) {
        EventService.$emit('widget-update-height', widgetUUID, size)
      }

      // update settings panel
      Vue.nextTick(() => EventService.$emit('widget-select-by-uuid', widgetUUID))
    },
    onHighlightWidget(wbUUID: string) {
      this.highlighted = wbUUID === this.widget.wbUUID
    },
    enterEditMode() {
      this.dragAction = new DragDropAction(this.$el as HTMLElement, () => this.widget)
      this.resizeAction = new ResizeAction(this.$el as HTMLElement, () => this.widget)
        .onResizeStart(this.onResizeStart.bind(this))
        .onResizeEnd(this.onResizeEnd.bind(this))
        .onResize(this.onResize.bind(this))

      DragDropService.registerDragAction(this.dragAction)

      EventService.$on('widget-select', this.onWidgetSelectEvent)
      EventService.$on('widget-select-by-uuid', this.onWidgetSelectByUuidEvent)
      EventService.$on('widget-highlight-by-uuid', this.onHighlightWidget)

      ResizeService.processWidget(this.$el as HTMLElement, this.widget)
    },
    finishEditMode() {
      EventService.$off('widget-select', this.onWidgetSelectEvent)
      EventService.$off('widget-select-by-uuid', this.onWidgetSelectByUuidEvent)
      EventService.$off('widget-highlight-by-uuid', this.onHighlightWidget)

      DragDropService.unregisterDragAction(this.dragAction)

      this.dragAction = null
      this.resizeAction = null
    }
  },
  updated() {
    if (JSON.stringify(this.widget) === window.widgets[this.widget.wbUUID]) {
      return
    }
    window.widgets[this.widget.wbUUID] = JSON.stringify(this.widget)
    ResizeService.processWidget(this.$el as HTMLElement, this.widget)
  },
  mounted() {
    window.widgets = window.widgets || []
    window.widgets[this.widget.wbUUID] = JSON.stringify(this.widget)

    EventService.$on('wb-enter-edit-mode', this.enterEditMode)
    EventService.$on('wb-finish-edit-mode', this.finishEditMode)
    EventService.$on('wb-cancel-edit-mode', this.finishEditMode)

    if (this.isEditable) {
      this.enterEditMode()
    }

    ResizeService.processWidget(this.$el as HTMLElement, this.widget)
  },
  destroyed() {
    if (window.widgets) {
      delete window.widgets[this.widget.wbUUID]
    }

    EventService.$off('wb-enter-edit-mode', this.enterEditMode)
    EventService.$off('wb-finish-edit-mode', this.finishEditMode)
    EventService.$off('wb-cancel-edit-mode', this.finishEditMode)

    this.finishEditMode()
  }
})
